import * as React from "react";

export function ExcludeIcon({
  fill = "#1A2547",
  stroke = "#1A2547",
  strokeWidth = 2,
  onClick,
}: {
  fill?: string;
  stroke?: string;
  strokeWidth?: number;
  onClick?: () => void;
}): JSX.Element {
  return (
    <div
      style={{
        display: "flex",
        position: "relative",
        cursor: onClick ? "pointer" : "default",
      }}
      onClick={onClick}
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
          d="M14.8242 12.4707C14.8242 14.1275 13.4811 15.4707 11.8242 15.4707H9.17578V11.5273C9.17578 9.87049 10.5189 8.52734 12.1758 8.52734H14.8242V12.4707Z"
          fill={fill}
        />
        <rect x="3.4375" y="3.4375" width="10.3869" height="11.0331" rx="2" stroke={stroke} strokeWidth={strokeWidth} />
        <rect
          x="10.1758"
          y="9.53125"
          width="10.3869"
          height="11.0331"
          rx="2"
          stroke={stroke}
          strokeWidth={strokeWidth}
        />
      </svg>
    </div>
  );
}
